import { createApi } from '@reduxjs/toolkit/query/react';
import { isServer } from 'tradera/utils/nextjs';
import { isomorphicWebApiBaseQuery } from 'tradera/state/services/utils/webapi-base-query';
import type {
    ValuationSearchRequest,
    ValuationSearchApiResponse,
} from './types/webapi-discover-generated';

export const valuationApi = createApi({
    reducerPath: 'valuationApi',
    baseQuery: isomorphicWebApiBaseQuery,
    endpoints: (builder) => ({
        getValuation: builder.query<
            ValuationSearchApiResponse,
            ValuationSearchRequest
        >({
            query: (params: ValuationSearchRequest) => {
                const baseUrl = isServer ? '' : '/api/webapi';
                const searchParams = new URLSearchParams(
                    Object.entries(params)
                        .filter(([, value]) => value != null)
                        .map(([key, value]) => [key, value.toString()]),
                );
                return `${baseUrl}/discover/valuation-search?${searchParams.toString()}`;
            },
        }),
    }),
});

export const { useGetValuationQuery } = valuationApi;
